(function () {
  function initAccordions(scope) {
    var details = (scope || document).querySelectorAll(
      ".product__accordion details",
    );

    details.forEach(function (detail) {
      if (detail._gsapAccordion) return;
      detail._gsapAccordion = true;

      var summary = detail.querySelector("summary");
      var content = detail.querySelector(".accordion__content");
      var caret = detail.querySelector(".icon-caret");

      // Garantir estado inicial fechado
      content.style.overflow = "hidden";
      content.style.height = "0";
      content.style.opacity = "0";
      detail.open = true; // Manter open para acessibilidade, controlamos via CSS

      summary.addEventListener("click", function (e) {
        e.preventDefault();

        var isOpen = detail.classList.contains("is-open");

        if (isOpen) {
          // Fechar
          gsap.to(content, {
            height: 0,
            opacity: 0,
            duration: 0.35,
            ease: "power2.inOut",
            onComplete: function () {
              detail.classList.remove("is-open");
            },
          });
          if (caret) {
            gsap.to(caret, {
              rotation: 0,
              duration: 0.35,
              ease: "power2.inOut",
            });
          }
        } else {
          // Abrir
          detail.classList.add("is-open");
          gsap.set(content, { height: "auto" });
          var fullHeight = content.offsetHeight;
          gsap.fromTo(
            content,
            { height: 0, opacity: 0 },
            {
              height: fullHeight,
              opacity: 1,
              duration: 0.4,
              ease: "power2.out",
              onComplete: function () {
                content.style.height = "auto";
              },
            },
          );
          if (caret) {
            gsap.to(caret, {
              rotation: 180,
              duration: 0.35,
              ease: "power2.inOut",
            });
          }
        }
      });
    });
  }

  // Aguardar GSAP estar disponível
  function ready() {
    if (typeof gsap !== "undefined") {
      initAccordions();
    } else {
      // GSAP carregado com defer, aguardar
      window.addEventListener("load", function () {
        initAccordions();
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ready);
  } else {
    ready();
  }

  document.addEventListener("shopify:section:load", function (e) {
    initAccordions(e.target);
  });
})();
